<template>
  <footer class="footer">
    <section class="bg-darkest-blue py-5 footer__copyright">
      <div class="container">
        <img alt="MoneySmart" src="https://assets.cdn-moneysmart.com/assets/cargo/svg/w5vwxizv54d1kcnlfsds.svg">
        <p>{{ $t('email_capture.copyright', { year }) }}</p>
      </div>
    </section>
  </footer>
</template>

<script>
export default {
  name: 'EmailCaptureFooter',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    position: relative;
    bottom: 0;
    width: 100%;
    text-align: center;

    @include respond-to(tablet) {
      text-align: unset;
    }

    img {
      width: 150px;

      @include respond-to(phablet) {
        width: 200px;
      }
    }

    &__copyright {
      font-size: .75rem;
      text-align: unset;

      @include respond-to(tablet) {
        text-align: unset;

        p {
          float: right;
          font-size: 1rem;
        }
      }
    }
  }
</style>
